import { supabase } from "@/integrations/supabase/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

type ToggleArgs = {
  icd10CodeId: string;
  shouldBeMandatory: boolean;
};

export const useToggleIcd10Comorbidity = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ icd10CodeId, shouldBeMandatory }: ToggleArgs) => {
      if (shouldBeMandatory) {
        // Ensure a row exists with always_code = true (and clear never_code)
        const { error } = await supabase.from("icd_10_co_morbidities_codes").upsert(
          {
            icd_10_code_id: icd10CodeId,
            always_code: true,
            never_code: false,
            updated_at: new Date().toISOString(),
          },
          { onConflict: "icd_10_code_id" },
        );
        if (error) throw error;
      } else {
        // Remove any reference row for this code
        const { error } = await supabase.from("icd_10_co_morbidities_codes").delete().eq("icd_10_code_id", icd10CodeId);
        if (error) throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["icd10-codes"] });
      toast.success("Updated mandatory co-morbidity flag");
    },
    onError: (_error) => {
      toast.error("Failed to update mandatory co-morbidity");
    },
  });
};
